<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <page-header v-if="$route.meta.needHeader"></page-header>
      <router-view />
      <page-footer v-if="$route.meta.needFooter"></page-footer>
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import PageHeader from "@/components/pageHeader/PageHeader";
import PageFooter from "@/components/pageFooter/PageFooter";

moment.locale("zh-cn");
export default {
  name: "app",
  components: { PageHeader, PageFooter },
  data() {
    return {
      zh_CN,
    };
  },
  mounted() {
    // console.log(this.$route.meta);
  },
};
</script>

<style lang="less">
</style>
